import {
  RESET_USER_COURSE,
  RESET_USER_COURSE_SUCCESS,
  RESET_USER_COURSE_CLEAN,
  RESET_USER_COURSE_ERROR,
} from "./actionTypes"

export const resetUserCourse = form => ({
  type: RESET_USER_COURSE,
  payload: { form },
})

export const resetUserCourseSuccess = () => ({
  type: RESET_USER_COURSE_SUCCESS,
  payload: {},
})

export const resetUserCourseClean = () => ({
  type: RESET_USER_COURSE_CLEAN,
  payload: {},
})

export const resetUserCourseError = error => ({
  type: RESET_USER_COURSE_ERROR,
  payload: error,
})